module.exports = __webpack_public_path__ + "img/question16c4.02eaf9c8.png";